function init_walkgame(from_php){
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    if(_ON_DEV){
        console.table(from_php);
    }
    var main=$(".place.walkgame");


    var semaphoreSuit= new mySemaphore();

    var girl_id=intval(from_php.girl_id);

    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex(),
        "loader":_moduleTimeHandler.getNewIndex()
    };

    var girl_name=$.takeGirlImage(girl_id);

    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var game_state="";
    var game_start=0;
    var secureStr=from_php.secure;

    var game;


    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });

    main.find(".bookGame").one("open",function(){
        var radius=0,dir_rot=2,dir=1,step=0,obj=main.find(".formSubmit.butLoader.soccer"),
        circleObj=obj.find(".img"),textObj=obj.find(".in"),step_mig=20;
        _moduleTimeHandler.set(timeIndexArr.loader,function(){
            radius=(radius+dir_rot)%360;
            step+=dir;
            circleObj.cssrotate(radius);
            if(step%step_mig<step_mig/2){
                textObj.addClass("hide");
            }
            else{
                textObj.removeClass("hide");
            }
        },50);
    });
    main.find(".bookGameIns").on("close",function(){
        main.find(".bookGame").bookUse("show");
        return false;
    });

    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"walkgame"};
            data_send=$.extend(data_send,to_send);

            function onError(data_send){
                if(typeof data_send.game_conf=="undefined"){
                    return false;
                }
                _eventLogout.add(data_send);
            }

            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.level)>intval(from_php.level)){
                        _mySound.playSound("girl_smile");
                    }
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("girl_moan");
                        //{$qconf.action_anim}/{$qevent_id}/{$g_id}/

                        $.goToLocation("walkanim/"+from_php.event_id+"/"+girl_id+"/");
                        return false;
                    }
                    if(typeof data.bought_live!="undefined"){
                        game.buyLife();
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },1500);
                    }
                    else{
                        isEnd();
                    }

                }
                else{
                    onError(data_send);
                }
                semaphoreSuit.clear();
            },"json");
        }
    }

    function takeImgConf(){
        var obj={
            "0":0,
            "1":1,
            "2":2,
            "3":3
        };
        var qconf={
          cherry:{"0":3,"1":2,"2":1,"3":0},
          linn:{"0":0,"1":1,"2":3,"3":2}
            // lola:{"0":2,"1":1,"2":5,"3":8,"4":6,"5":7,"6":3,"7":0,"8":4},
            // sanshi:{"0":0,"1":1,"2":2,"3":5,"4":8,"5":7,"6":6,"7":3,"8":4},
            // ice:{"0":0,"1":1,"2":2,"3":5,"4":8,"5":7,"6":4,"7":3,"8":6},
        };
        var ready=copyObj(obj);
        if(typeof qconf[girl_name]!="undefined"){
            ready=$.extend(ready,qconf[girl_name]);
        }
        return ready;
    }



    function updateState(){

        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.time_game){
            showState("game");
        }
        else{
            if(from_php.was_paid==0){
                if(from_php.try_count>0){
                    //showState("init");
                    postAjax({prepare_init:1});
                }
                else{
                    showState("need_try");
                }
            }
            else if(from_php.was_shown==0){
                showState("next");
            }
            else{
                showState("game_init");
            }
        }
        main.attr("data-level",(intval(from_php.level_show)+1))
    }

    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({prepare_init:1});


        });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           postAjax({buy_repeat:1});
        });
        main.find(".buyLiveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           postAjax({buy_live:1});
        });

        updateState();
    }


    var stateFun={
        "wrong":function(win){
            if(from_php.level>=1){
                main.find(".repeatMoveJS").show();
            }
            else{
                main.find(".repeatMoveJS").hide();
            }
            main.find("#failReasonJS").html(from_php.langs["fail"+from_php.was_error]);
            var liveRow=main.find(".buyLiveRowJS");
            if(game_state==""){
                liveRow.addClass("hide");
            }
            else{
                liveRow.removeClass("hide");
            }

            var canv=win.find(".canvasJS");
            if(!canv.is(".ready")){
                var app = new PIXI.Application({
                    width: 960, height: 600,antialias: true,transparent:true,
                    view:canv[0]
                });
                var cont=new PIXI.Container();
                app.stage.addChild(cont);
                cont.addChild(new myPixiObj.showText(from_php.langs.busted,{
                    pos:[480,430],
                    font_size:60,
                    font_color:"#ffffff",
                    border_color:"#520819",
                    border_size:8
                }));
                cont.addChild(new myPixiObj.showText(from_php.langs.busted,{
                     pos:[480,430],
                    font_size:60,
                    font_color:"#ffffff",
                    border_color:"#ff0036",
                    border_size:3
                }));
                _moduleEvents.one("moduleClear",function(){
                    if(typeof app!="undefined" && app!=null){
                        app.destroy();
                    }
                });

            }

        },
        "init":function(){

        },
        "need_try":function(){

        },
        "next":function(win){
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
            var canv=win.find(".canvasJS");
            if(!canv.is(".ready")){
                var app = new PIXI.Application({
                    width: 960, height: 600,antialias: true,transparent:true,
                    view:canv[0]
                });

                var cont=new PIXI.Container();
                app.stage.addChild(cont);
                cont.addChild(new myPixiObj.showText(from_php.langs.you_win,{
                    pos:[480,430],
                    font_size:60,
                    font_color:"#ffffff",
                    border_color:"#1b2d09",
                    border_size:8
                }));
                cont.addChild(new myPixiObj.showText(from_php.langs.you_win,{
                     pos:[480,430],
                    font_size:60,
                    font_color:"#ffffff",
                    border_color:"#a4ff00",
                    border_size:3
                }));

                var loaderMain = new PIXI.loaders.Loader();

                loaderMain.add("lock",_IMG_SERV+"/gfx/place/walkgame/next/lock.png");
                loaderMain.add("lock_cover",_IMG_SERV+"/gfx/place/walkgame/next/lock_cover.png");
                loaderMain.add("girl",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/parts/full.jpg");
                loaderMain.load(function(loader, resources){
                    var level,level_max=Math.min(from_php.level,from_php.level_max),
                    conf=takeImgConf();
                    var cover=new PIXI.Container();
                    cover.addChild(new myPixiElement.img({img:"girl",anchor:[0,0],pos:[26,14]}));

                    cover.pivot.x=286;
                    cover.pivot.y=0;
                    cover.x=480;
                    cover.y=25;

                    var lock=new PIXI.Container();
                    lock.x=35;
                    lock.y=29;
                    var lock_conf=[
                        [[0,254],[254,250]],
                        [[0,149],[149,148]]
                    ];
                    var i=0,pos;
//                    level_max=9;
                    for(level=from_php.level_show;level<from_php.level_show_max;level++){
                        i=conf[level];
                        pos=[i%2,Math.floor(i/2)];
// console.table({
//   pos:[lock_conf[0][pos[0]][0],lock_conf[1][pos[1]][0]],
//   size:[lock_conf[0][pos[0]][1],lock_conf[1][pos[1]][1]],//new image size
//   cropPos:[lock_conf[0][pos[0]][0],lock_conf[1][pos[1]][0]]
// });
                        lock.addChild(new myPixiElement.imgCrop({
                            img:"lock",anchor:[0,0],
                            pos:[lock_conf[0][pos[0]][0],lock_conf[1][pos[1]][0]],
                            size:[lock_conf[0][pos[0]][1],lock_conf[1][pos[1]][1]],//new image size
                            cropPos:[lock_conf[0][pos[0]][0],lock_conf[1][pos[1]][0]]
                        }));
// break;
                    }
                    cover.addChild(lock);

//                    cover.addChild(new myPixiElement.img({img:"lock",anchor:[0,0],pos:[27,24]}));
                    cover.addChild(new myPixiElement.img({img:"lock_cover",anchor:[0,0],pos:[0,0]}));

                    app.stage.addChild(cover);
                });


                _moduleEvents.one("moduleClear",function(){
                    $(document).off("keydown.walker");
                    if(typeof app!="undefined" && app!=null){
                        app.destroy();
                    }
                    if(typeof loaderMain.reset!="undefined"){
                        loaderMain.reset();
                    }
                });
            }


        },
        "game_init":function(){

            game=new gameAll();
            game.init();
            gameCover.addClass("hide");

            var event2sound={
                "clear_area":{sound:"crab_in"},
                "start_event":{sound:"hall_magic"},
                "start_game":{sound:"intruder"},
                "lose_life":{sound:"game_lose"},
            },
            stopDron=["lose_life","clear_area","game_lose"];

            var droneIndex;

            _moduleEvents.on("walksound",function(val){
                if(val=="game_lose"){
                    _mySound.playSound("cuffs");
                    _mySound.playSound("walk_lose_all");
                }
                if(val=="drone_start"){
                    droneIndex=_mySound.playSound("drone");
                }
                if(val=="lose_life"){
                    _mySound.playSound("walk_lose_life");
                }
                if(in_array(val,stopDron) && droneIndex){
                    _mySound.stopSound(droneIndex);
                }
                if(typeof event2sound[val]!="undefined"){
                    _mySound.playSound(event2sound[val].sound);
                }
            });

            _moduleEvents.one("moduleClear",function(){
                if(droneIndex){
                    _mySound.stopSound(droneIndex);
                }
            });



        },
        "game":function(){
             gameCover.addClass("hide");
             main.find(".hideOnGameJS").addClass("hide");
             main.find(".showOnGameJS").removeClass("hide");
        }
    };
    function showState(state){

        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".repeatMoveTriggerJS>.in .leftRepeat").html(from_php.repeat_count);
        if(from_php.repeat_count<1){
          main.find(".repeatMoveTriggerJS").addClass("unable");
        }
        main.find(".buyLiveTriggerJS>.in .leftLife").html(from_php.buy_life);
        if(from_php.buy_life<1){
          main.find(".buyLiveTriggerJS").addClass("unable");
        }
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.walkgame .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }


        state_cur=state;

        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        gameCoverWin.find(".textfill").textfill();
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        stateFun[state](gameCoverWin);
    }








    function gameAll(){
        var walkObj;


        var thc=this;

        var book=main.find("#bookGameJS");
        book.bookUse("show");
        function startGame(){
            postAjax({start_game:1});
            book.bookUse("hide");
            main.find(".bookGameIns.book").off("close").bookUse("hide");

            main.find(".hideOnGameJS").addClass("hide");
            game_start=getCurrentTime();
            game_state="game";
            walkObj.start();
        }
        function showMobile(){
            main.find(".changeModeJS").removeClass("hide");
        }
        function showDesktop(){
            main.find(".ctrDesktop").removeClass("hide");
        }
        function wasLoaded(){
            main.find(".gameIsLoadingJS").addClass("hide");
            main.find(".gameIsLoadedJS").removeClass("hide");
            main.find(".gameIsLoadedJS").find(".textfill").textfill();
            if(walkObj.isMobile()){
                showMobile();
            }
            else{
                showDesktop();
            }
            main.find(".gameStartJS").one("click",function(){
                startGame();
            });
            _moduleTimeHandler.clear(timeIndexArr.loader);

            var ctrKey="";
            main.find(".changeModeJS").click(function(){
                var ctr=walkObj.changeMobileCtr();
                $(this).attr("data-type",ctr);
                main.attr("data-ctr",ctr);
            });



        }

        this.life={cur:3,max:3};

        var event_arr=[];
        if(from_php.bonus1 || 1==1){
            event_arr.push("slow");
        }
        if(from_php.bonus2 || 1==1){
            event_arr.push("stop");
        }

        var cellBackArr=[
            _IMG_SERV+"/gfx/place/walkgame/back_hidder.jpg",
            _IMG_SERV+"/gfx/place/walkgame/covers/2.jpg",
            _IMG_SERV+"/gfx/place/walkgame/covers/3.jpg",
            _IMG_SERV+"/gfx/place/walkgame/covers/4.jpg",
            _IMG_SERV+"/gfx/place/walkgame/covers/5.jpg",
        ];


        var img_show=takeImgConf()[from_php.level_show];
        walkObj=new walkGame(main.find("#gameWrapJS"),{
            security_count:from_php.conf.security_max,
            security_speed:from_php.conf.security_speed,
            walker_speed:170,
            dronAnims:["animation","animation2","animation3"],
            event_arr:event_arr,
            img_all:{
                ui_main:_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/parts/"+img_show+".jpg",
                cell_back:cellBackArr[mt_rand(0,cellBackArr.length-1)],
            },
            onSucc:function(cur,full){
                if(game_state=="game"){
                   var pointObj=main.find("#readyJS");
                   var points_need=Math.floor(full*(100-from_php.conf.cover)/100);
                   var points=Math.floor(full-cur);

                   var percent=Math.round(Math.min(1,points/points_need)*10000);
                   percent=Number.parseFloat(percent/100).toFixed(2);
                   pointObj.find(".wrapPointsJS").html(percent+'%');


                   if(points>=points_need){
                       game_state="win";
                       walkObj.setGameState("win");
                       postAjax({
                           game_conf:Base64.encode(secureStr),
                           howlong:(getCurrentTime()-game_start),
                           is_mobile:walkObj.isMobile()
                       });
                   }
                }
            },
            onFail:function(type_id){
                if(game_state=="game"){
                    thc.life.cur--;
                    thc.updateLife();
                    if(thc.life.cur<=0){
                        game_state="lose";
                        walkObj.setGameState("lose");
                        _moduleEvents.trigger("walksound","game_lose");
                        postAjax({was_error:type_id});
                    }
                    else{
                        _moduleEvents.trigger("walksound","lose_life");
                    }
                }
            },
            onLoad:function(){
                wasLoaded();
            }
        });
        this.walkObj=walkObj;


    }
    gameAll.prototype={
        init:function(){
            this.updateLife();
        },
        updateLife:function(){
            var pointObj=main.find("#readyJS");
            pointObj.find('.liveWrapJS').attr("data-live",this.life.cur);
            if(typeof this.walkObj.walker!="undefined"){
                this.walkObj.walker.setLive(this.life.cur,this.life.max);
            }
        },
        buyLife:function(){
            if(game_state=="lose"){
                game_state="game";
                this.walkObj.setGameState("game");
                this.life.cur=1;
                this.updateLife();
            }
        }
    };



    $(document).off("keydown.walker2").on("keydown.walker2",function(e){
        if(e.which==13){
            main.find(".triggerEnterJS:visible").each(function(){
                var th=$(this);
                if(!th.is(".hide") && th.closest(".hide").length==0){
                    th.trigger("click");
                }
            });
        }
    });
    _moduleEvents.one("moduleClear",function(){
        $(document).off("keydown.walker2");
    });

    init();


//    main.find(".bookGame").css("background-image","none").
//    find(".up,.down").css("background-image","none").end().
//    find(".ball_down").addClass("hide").end().
//    find(".bottom_row").addClass("hide");

}
